import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "tv_admin_token";

export const api = axios.create({ baseURL: API });

// Attach stored admin token (if any) on load
const stored = typeof localStorage !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common["Authorization"];
  }
};

export const getAuthToken = () =>
  typeof localStorage !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => {
    setAuthToken(r.data.token);
    return r.data.token;
  });

export const adminVerify = () => api.get("/admin/verify").then((r) => r.data);

// Public
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const subscribe = (email, callsign) =>
  api.post("/subscribe", { email, callsign }).then((r) => r.data);
export const checkCallsign = (callsign) =>
  api.get("/subscribe/callsign-check", { params: { callsign } }).then((r) => r.data.available);

// Admin (require token)
export const updateFeaturedVideo = (video, title) =>
  api.put("/settings/featured-video", { video, title }).then((r) => r.data);
export const getSubscribers = () => api.get("/subscribers").then((r) => r.data);
export const updateSubscriberCallsign = (id, callsign) =>
  api.patch(`/subscribers/${id}`, { callsign }).then((r) => r.data);
export const deleteSubscriber = (id) =>
  api.delete(`/subscribers/${id}`).then((r) => r.data);
export const bulkDeleteSubscribers = (ids) =>
  api.post("/subscribers/bulk-delete", { ids }).then((r) => r.data);
export const getSubscriberAnalytics = () =>
  api.get("/subscribers/analytics").then((r) => r.data);
export const broadcastNewEpisode = (opts = {}) =>
  api.post("/broadcast/new-episode", opts).then((r) => r.data);
export const publicUnsubscribe = (token) =>
  api.post("/unsubscribe", { token }).then((r) => r.data);
export const exportSubscribersUrl = () =>
  `${API}/subscribers/export?token=${encodeURIComponent(getAuthToken() || "")}`;

// Tip line
export const submitTip = (formData) =>
  api.post("/tips", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const getTips = () => api.get("/tips").then((r) => r.data);
export const updateTipStatus = (id, status) =>
  api.patch(`/tips/${id}/status`, { status }).then((r) => r.data);
export const replyToTip = (id, message) =>
  api.post(`/tips/${id}/reply`, { message }).then((r) => r.data);
export const deleteTip = (id) => api.delete(`/tips/${id}`).then((r) => r.data);
export const tipFileUrl = (tipId, fileId) =>
  `${API}/tips/${tipId}/files/${fileId}?token=${encodeURIComponent(getAuthToken() || "")}`;
